<template>
  <router-link tag="div" :to="to" :event="disabled ? '' : 'click'" :class="tileClasses">
    <div class="row justify-content-center">
      <img :src="image" class="tile-icon" />
    </div>
    <div class="tile-title">
      <slot></slot>
    </div>
  </router-link>
</template>

<script>
import classNames from 'classnames'

export default {
  props: {
    to: {
      type: Object,
      required: true
    },

    image: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tileClasses () {
      return classNames(
        'menu-tile',
        'col-12',
        'col-sm-6',
        'col-md-4',
        'col-lg-4',
        'col-xl-12',
        this.disabled && 'inactive-tile'
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../assets/stylus/menu.styl"

.menu-tile
  height: 180px
  background-color: #007CDB
  max-width: 260px
  padding: 30px
  margin: 15px
  color: white
  border-radius: 2px
  cursor: pointer
  transition: all .2s ease-in-out

  &:hover
    background-color: #0758B7
    transform: scale(1.05)
    box-shadow: 0 12px 20px 0 rgba(0,0,0,0.12)

    & .tile-icon
      transform: translate(0, -20px) scale(1.6)

  .tile-icon
    height: 60px
    transition: all .2s ease-in-out

  .tile-title
    color: white
    text-align: center
    font-weight: 500
    font-size: 18px
    position: absolute
    bottom: 20px
    width: 200px

.inactive-tile
  background-color: #4C5B5C !important
  cursor: not-allowed
</style>



// WEBPACK FOOTER //
// src/components/MenuTile.vue